module.exports = __webpack_public_path__ + "static/media/back shot of printed tunic.1eca85e2.jpg";